"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../../styles");

var styles = {
  root: {
    overflow: 'auto',
    background: _styles.colors.raven,
    borderRadius: '0 0 3px 3px',
    boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0 , 0.5)',
    height: function height(_ref) {
      var _height = _ref.height;
      return _height;
    }
  }
};
var _default = styles;
exports["default"] = _default;